module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_03_sp-570b21610db46a4aaf4b86c43b9f16d3.png";